import Ad from "../gpt/Ad";

export default class AdObserver {

    _isRunning: boolean;
    _adsMap: Map<string, Ad>;
    _observer: IntersectionObserver;

    constructor(callback: (ad: Ad) => void, observerOptions: IntersectionObserverInit) {

        this._isRunning = false;
        this._adsMap = new Map();
        this._observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && this._isRunning) {
                    const ad = this._adsMap.get(entry.target.id);

                    if (ad?.isDisplayable()) {
                        callback(ad);
                    }
                    this._adsMap.delete(entry.target.id);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            ...observerOptions
        });
    }

    start() {
        this._isRunning = true;
    }

    stop() {
        this._isRunning = false;
    }

    destroy() {
        this._adsMap.clear();
        this._observer.disconnect();
    }

    startObserving(ad: Ad) {
        if (!this._adsMap.has(ad.getId())) {
            this._adsMap.set(ad.getId(), ad);

            const adElement = ad.getElement();

            if (!adElement) return;

            this._observer.observe(adElement);
        }
    }

}
